import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { setNotificationBannerHidden, setNotificationHeight } from 'src/modules/App/actions'
import NotificationBanner from './NotificationBanner'

const mapStateToProps = (state) => {
  return {
    isNotificationHidden: state.appReducer.isNotificationHidden,
    areAppActionsDisabled: state.nonPersistentAppReducer.areAppActionsDisabled,
    notificationHeight: state.appReducer.notificationHeight
  }
}

const mapDispatchToProps = {
  setNotificationBannerHidden,
  setNotificationHeight
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NotificationBanner))
